module.exports = __webpack_public_path__ + "img/icon_vip_hat.6ec0ea11.svg";